export default __webpack_public_path__ + "static/media/user.c8730cfe.svg";